"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 20.5",
    width: "24.5",
    height: "20.5"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M20.7,15.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M18.6,11.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M17.5,9.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M15.2,5.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,20.5H0.5c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.2-0.1-0.4,0-0.5L5.5,11l0.9,0.5l-4.9,8h21.7l-2.8-4.5l0.8-0.5l3.3,5.2 c0.1,0.2,0.1,0.3,0,0.5C24.4,20.4,24.2,20.5,24,20.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.8,5.9l-2.5-4.4L11,3.8l-0.9-0.5l1.7-3C11.9,0.1,12.1,0,12.3,0l0,0c0.2,0,0.3,0.1,0.4,0.3l2.9,5.1L14.8,5.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#9ECE06",
    d: "M16.9,18.8C16.9,18.8,16.8,18.8,16.9,18.8c0-0.4,0.1-0.7,0.3-1 c0.1-0.5,0.1-0.5,0.1-1.1C17,16.2,17,16.2,16.8,16c-0.2-0.1-0.4-0.2-0.6-0.4c-0.9-0.3-1.8-0.5-2.8-0.8c-0.9,0-0.9,0-1.1,0 c0,0.1-0.1,0.2-0.1,0.3c0,0.3,0,0.5,0,0.8c0.3,1,0.5,1.9,0.8,2.9c-0.8,0-1.5,0-2.3-0.1c0.1-0.3,0.1-0.6,0.2-0.8c0-0.3,0-0.5,0-0.8 c-0.6-1.7-1.1-3.3-1.7-5c0-0.1,0-0.1,0-0.2c-0.5,0-0.9-0.1-1.4-0.1c0-0.7,0-1.4,0-2.1C7.6,9.2,7.6,9.2,7.5,9.1C7,9,7,9,5.7,9 c0,0,0,0-0.1-0.1c0.2-0.3,0.5-0.5,0.6-0.7c0-0.1,0-0.1,0-0.2C6.1,8.1,6.1,8,6,8c-0.4,0-0.8-0.1-1.2-0.1c-0.3-0.1-0.6-0.1-1-0.2 C3,7.3,3,7.3,2.8,7.1C2.4,6.5,2.4,6.5,2.1,6c0,0,0-0.1,0-0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.4 C3.4,6.8,3.6,6.9,3.8,7c0.3,0,0.6,0,0.9,0c0,0,0,0,0-0.1c-0.4-0.4-0.4-0.4-0.8-1C3.9,5.7,3.8,5.5,3.7,5.3c0-0.2-0.1-0.3-0.1-0.5 c0-0.2,0-0.5,0.1-0.8c0.1-0.2,0.1-0.3,0.2-0.5C3.9,3.4,4.1,3.2,4.2,3c0.1-0.1,0.3-0.3,0.5-0.4c1.8-1.2,1.8-1.2,2-1.4 c0-0.1,0-0.2,0-0.3C6.6,0.8,6.5,0.7,6.5,0.7c-0.1,0-0.2,0-0.3,0C6.1,0.7,6,0.8,5.9,0.9c0-0.1,0-0.2,0-0.4C5.8,0.4,5.8,0.4,5.7,0.3 c-0.1,0-0.3-0.1-0.4-0.1c0-0.2,0-0.2,0.1-0.2c0.3,0,0.7,0,1,0C6.6,0.1,6.8,0.1,7,0.2c0.2,0.2,0.2,0.2,0.4,0.5c0,0.1,0,0.2,0.1,0.3 c0,0.1,0,0.2-0.1,0.4C7.2,1.7,7.2,1.7,7,1.9C5.9,2.7,5.9,2.7,5.2,3.3C5.1,3.4,5,3.6,4.9,3.8c0,0.2,0,0.4,0,0.6 C5,4.5,5.1,4.6,5.1,4.7C5.5,4.9,5.5,4.9,5.7,5c0.3,0,0.7,0,1.1,0c0.4-0.1,0.8-0.3,1.1-0.4c0.1,0,0.3,0,0.4,0 c0.2,0.1,0.4,0.3,0.6,0.4C9,5,9,5,13.2,5.1c0,1.2,0,2.2-0.1,2.5c0,0.1,0,0.2,0,0.2c0.1-0.2,0.1-0.2,0.2-0.6c1.5,0,1.5,0,2.1,0 C16,7.4,16,7.4,16.7,7.6C17,7.7,17.3,7.8,17.6,8c0.2,0.1,0.4,0.3,0.5,0.4c0.3,0.3,0.5,0.6,0.8,1c0.2,0.4,0.2,0.4,0.4,0.9 c0.1,0.3,0.1,0.5,0.2,0.8c0,0.4,0,0.8,0,1.2C19.4,13,19.4,13,19,15c0,0.4,0,0.9,0,1.3c-0.1,0.1-0.1,0.1-0.3,0 c-0.1-0.1-0.1-0.1,0-2.9c0,0-0.1,0-0.1,0c-0.1,5.3-0.1,5.3-0.2,5.4C17.9,18.8,17.4,18.8,16.9,18.8L16.9,18.8z"
  }));
};

exports["default"] = _default;